import {Alert, Button, Stack, Box, TextField, CircularProgress} from '@mui/material';
import {LoadingButton} from '@mui/lab';
import {useState, useEffect} from 'react';
import {Tags as API} from '../../../services/API/Tags';
import { useNavigate, useParams } from 'react-router-dom';
import Layout from "../../../components/Frames/Layout"
import TagTypeSelect from './TagTypeSelect';
import RelatedTags from './RelatedTags';

export default function Form(){

    const {id} = useParams();
    const [item, setItem] = useState(null);
    const navigate = useNavigate();
    const [error, setError] = useState(false)
    const [submitting, setSubmitting] = useState(false)

    useEffect(() => {

        if(id !== 'new'){

            API.getOne(id)
                .then(r => setItem(r.data))
                .catch(e => console.log(e))

        }else{
            const defaultItem = {
                title: '',
                type: {id: 'discipline', title: 'Discipline'},
                color: '#6495ED'
            };

            setItem(defaultItem)
        }
                
    }, [id])


    const handleChange = props => {
        let copy = {...item};
        Object.assign(copy, props);
        return setItem(copy);
    }

    const handleSubmit = e => {
        e.preventDefault();

        setSubmitting(true);

        if(id === 'new'){
            API.post(item)
                .then(r => handleSuccess())
                .catch(e => setError(e.response.status))
        }else{
            API.put(item)
                .then(r => handleSuccess())
                .catch(e => setError(e.response.status))
        }
        
        return setError(false);
    }

    const handleSuccess = () => {
        return navigate('/admin/tags');
    }

    return <Layout title="Mots clés" tab="tags" menu="admin">

        {item && <form onSubmit={e => handleSubmit(e)} encType="multipart/form-data">

            <Stack direction='column' alignItems='center' spacing={3}>

                {error && <Box width='350px'>
                    <Alert severity='error'>{error}</Alert>
                </Box>}


                <Box width='350px'>
                    <TextField
                        label='Mot clé'
                        type='text'
                        size='small'
                        value={item.title}
                        onChange={e => handleChange({title: e.target.value})}
                        fullWidth
                        required
                        min={0}
                    />
                </Box>

                <Box width="350px">
                    <TagTypeSelect 
                        value={item.type.id}
                        disabled
                    />
                </Box>

                <Box width="350px">
                    <RelatedTags id={item.id} />
                </Box>

                <Stack width="350px" direction='row' spacing={2} justifyContent='end'>
                    <Button variant='outlined' type='button' onClick={() => navigate('/admin/tags')}>Annuler</Button>
                    <LoadingButton 
                        variant='contained' 
                        type='submit' 
                        loading={submitting && !error}
                    >Valider</LoadingButton>
                </Stack>

            </Stack>

        </form>}

        {!item && <Stack direction='row' justifyContent='center' style={{margin: 20}}>
            <CircularProgress size={24} />
        </Stack>}

    </Layout>
}